document.addEventListener('DOMContentLoaded', function () {
    var showHideButtons = document.querySelectorAll('.js-show-hide-button');

    if (showHideButtons) {
        showHideButtons.forEach((button) => {
            button.addEventListener('click', handleShowHide);

            if (button.dataset.showByDefault === 'false') {
                var targetElement = document.getElementById(button.dataset.targetId);
                if (targetElement) {
                    targetElement.classList.add('hidden');
                }
            }
        });
    }
});

const handleShowHide = (e) => {
    var currentButton = e.target;

    var targetElement = document.getElementById(currentButton.dataset.targetId);

    if (targetElement) {
        if (targetElement.classList.contains('hidden')) {
            targetElement.classList.remove('hidden');
            targetElement.scrollIntoView();
            currentButton.setAttribute('aria-expanded', 'true');
            currentButton.textContent = currentButton.dataset.expandedButtonText;

            // to handle login iframe height issue
            if (targetElement.dataset.contentElementTypeAlias === 'registerBlock') {
                var loginSection = targetElement.querySelector('.js-login-section');
                if (loginSection && !loginSection.classList.contains('hidden')) {
                    cultureCode = document.getElementById('siteCulture').value;
                    loginSection.querySelector('.js-loginIframe').src =
                        '/api/azureb2c/beginlogin?culture=' + cultureCode;
                }
            }
        } else {
            targetElement.classList.add('hiding');
            currentButton.setAttribute('aria-expanded', 'false');
            currentButton.textContent = currentButton.dataset.buttonText;

            // WM-886: hang the tidy-up on the fade-out itself. With animation
            // effects off in the OS the fade completes immediately, so waiting
            // out a fixed second left the block holding its space, invisible.
            whenAnimationsDone(targetElement, 1000, () => {
                targetElement.classList.add('hidden');
                targetElement.classList.remove('hiding');
                // check if next element is visible, if not, remove section--visible
                var nextElement = targetElement.nextElementSibling;
                // may need to tweak logic to make the animations nicer here
                if (nextElement && nextElement.classList.contains('section--visible')) {
                    nextElement.classList.remove('section--visible');
                }

                Core.handleLayoutItems();
            });
        }
    }
};
